import React from 'react';
import cx from 'classnames';

const Clickable = ({ children, onClick, className = '', style = {} }) => {
  return (
    <button
      className={cx('d-flex align-items-center', className)}
      style={{
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        margin: 0,
        padding: '4px',
        font: 'inherit',
        outline: 'none',
        color: 'inherit',
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Clickable;
